import React, { useState, useEffect, useRef } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { SelectButton } from "primereact/selectbutton";
import { Dialog } from "primereact/dialog";
import { Editor } from "primereact/editor";
import { InputText } from "primereact/inputtext";
import Pagination from "./Pagination";
import "./Pagination.css"
import { ProgressSpinner } from 'primereact/progressspinner';
// import { Form, Field } from "react-final-form";
import { instance } from "../../api";
const emptyService = {
    id_type_service_gexpertise: "",
    libelle: "",
    libelle_gexonline: "",
    photo: {},
    description: "",
    lien: "",
  };
  
  export default function Services() {
    const [services, setServices] = useState([]);
    const dt = useRef(null);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [filteredServices, setFilteredServices] = useState([]);
    const [service, setService] = useState(emptyService);
    const [editDialog, setEditDialog] = useState(false);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [searchText, setSearchText] = useState("");
    
    const toast = useRef(null);
    const [currentPage, setCurrentPage] = useState(1);
    //const dataPerPage = 10;
    const [dataPerPage, setDataPerPage] = useState(10);
    const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
    };
    
    const totalPages = Math.ceil((filteredServices?.length || 0) / dataPerPage);
    const lastIndex = currentPage * dataPerPage;
    const firstIndex = lastIndex - dataPerPage;
    const currentData = filteredServices?.slice(firstIndex, lastIndex) || [];
  
  
    const fetchServices = () => {
      instance
        .get(`/api/service/`)
        .then((response) => {
          setServices(response.data);
          setFilteredServices(response.data);
        })
        .catch((error) => console.error("Error fetching services:", error));
    };
    
  
    useEffect(() => {
      fetchServices();
    }, []);
  
    const handleSearchChange = (e) => {
      const value = e.target.value;
      setSearchText(value);
      const filtered = services.filter((s) =>
        s.libelle.toLowerCase().includes(value.toLowerCase())||
      s.id_type_service_gexpertise.toString().toLowerCase().includes(value.toLowerCase())
      );
      setFilteredServices(filtered);
    };
  
    const saveService = () => {
      setSubmitted(true);
    
      if (service.libelle.trim()) {
        const apiCall = service.id_type_service_gexpertise
          ? instance.put(`/api/service/update/${service.id_type_service_gexpertise}`, service)
          : instance.post(`/api/services/create`, service);
    
          apiCall
          .then(() => {
            // Fetch all services to find the updated one
            return instance.get(`/api/service/`);
          })
          .then((response) => {
            // Assuming response.data is an array of all services
            const updatedServices = response.data;
    
            // Find the updated service
            const updatedService = updatedServices.find(
              (s) => s.id_type_service_gexpertise === service.id_type_service_gexpertise
            );
    
            if (!updatedService) {
              console.error('Updated service not found.');
              return;
            }
    
            // Update `services` state
            setServices((prevServices) => {
              return prevServices.map((s) =>
                s.id_type_service_gexpertise === updatedService.id_type_service_gexpertise
                  ? { ...s, ...updatedService } // Merge updated data
                  : s
              );
            });
    
            // Update `filteredServices` if applicable
            setFilteredServices((prevFilteredServices) => {
              return prevFilteredServices.map((s) =>
                s.id_type_service_gexpertise === updatedService.id_type_service_gexpertise
                  ? { ...s, ...updatedService } // Merge updated data
                  : s
              );
            });
    
      
    
            setEditDialog(false);
            toast.current.show({
              severity: "success",
              summary: service.id_type_service_gexpertise ? "Service mis à jour" : "Service créé",
              detail: "Service modifié avec succès.",
              life: 3000,
            });
          })
          .catch((error) => {
            console.error("Error saving service:", error);
          });
      }
    };
    
  
    const confirmDeleteService = (service) => {
      setService(service);
      setDeleteDialog(true);
    };
    const deleteService = () => {
      if (!service || !service.id_type_service_gexpertise) {
        console.error("Invalid service ID:", service);
        return;
      }
    
      instance
        .delete(`/api/service/delete/${service.id_type_service_gexpertise}`)
        .then(() => {
          fetchServices(); // Refresh list or update UI as necessary
          setDeleteDialog(false);
          toast.current.show({
            severity: "success",
            summary: "Service supprimé",
            detail: "Service supprimé avec succès",
            life: 3000,
          });
        })
        .catch((error) => {
          if (error.response) {
            console.error("Error response:", error.response.data);
          } else if (error.request) {
            console.error("No response received:", error.request);
          } else {
            console.error("Error deleting service:", error.message);
          }
        });
    };
    
  
    const hideDialog = () => {
      setEditDialog(false);
      setService(emptyService);
    };
  
    const hideDeleteDialog = () => {
      setDeleteDialog(false);
    };
  
    const actionBodyTemplate = (rowData) => (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded succesBtn mr-2"
          onClick={() => {
            setService({ ...rowData });
            setEditDialog(true);
          
          }}
        />
        <Button
          icon="pi pi-trash"
          className="p-button-rounded succesBtn mr-2"
          onClick={() => confirmDeleteService(rowData)}
        />
      </React.Fragment>
    );
  
    const dialogFooter = (
      <React.Fragment>
        <Button label="Annuler" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
        <Button label="Sauvegarder" icon="pi pi-check" className="p-button-text" onClick={saveService} />
      </React.Fragment>
    );
  
    const deleteDialogFooter = (
      <React.Fragment>
        <Button label="Non" icon="pi pi-times" className="p-button-text" onClick={hideDeleteDialog} />
        <Button label="Oui" icon="pi pi-check" className="p-button-text" onClick={deleteService} />
      </React.Fragment>
    );
  
    const header = (
      <div className="table-header">
        <h5 className="mx-0 my-1">Liste services</h5>
        <span className="p-input-icon-right">
          <InputText
            type="search"
            value={searchText}
            onChange={handleSearchChange}
            placeholder="Chercher..."
          />
          <i className="pi pi-search" />
        </span>
        
      </div>
    );
  return (
    <div className="datatable-crud">
      <Toast ref={toast} />
      
      <DataTable
        ref={dt}
        value={filteredServices}
        dataKey="id"
        emptyMessage={ <ProgressSpinner />} 
        globalFilter={globalFilter}
        header={header}
       
        className="crudTable"
        scrollable
        scrollHeight="450px"
      >
        <Column
          field="id_type_service_gexpertise"
          header="ID "
          body={(rowData) => (
            <div className="table-data">
              <span className="mobile-header">ID </span>
              {rowData.id_type_service_gexpertise}
            </div>
          )}
         
        ></Column>
        <Column
          field="libelle"
          header="Libelle"
          body={(rowData) => (
            <div className="table-data">
              <span className="mobile-header">ILibelle </span>
              {rowData.libelle}
            </div>
          )}
        
        ></Column>
        <Column
          field="libelle_gexonline"
          header="Libelle GexOnline"
          body={(rowData) => (
            <div className="table-data">
              <span className="mobile-header">Libelle GexOnline </span>
              {rowData.libelle_gexonline}
            </div>
          )}
          
        ></Column> 
     
        <Column
          field="description"
          header="Description"
          body={(rowData) => (
            <div className="table-data">
              <span className="mobile-header">Description</span>
              {rowData.description}
            </div>
          )}
          
        ></Column>
        <Column
          field="lien"
          header="Lien"
          body={(rowData) => (
            <div className="table-data">
              <span className="mobile-header">Lien</span>
              {rowData.lien}
            </div>
          )}
          
        ></Column>
        <Column
          body={actionBodyTemplate}
          exportable={false}
          header="Actions"
     
        ></Column>
      </DataTable>
      <Dialog
        visible={editDialog}
        style={{ width: "450px" }}
        header="Détails du service"
        modal
        footer={dialogFooter}
        onHide={hideDialog}
      >
        <div className="p-field">
          <label htmlFor="libelle">Libelle</label>
          <InputText
            id="libelle"
            value={service.libelle}
            onChange={(e) => setService({ ...service, libelle: e.target.value })}
            required
            className={classNames({ "p-invalid": submitted && !service.libelle })}
          />
          {submitted && !service.libelle && <small className="p-error">Libelle est obligatoire.</small>}
        </div>
        <div className="p-field">
          <label htmlFor="description">Description</label>
          <Editor
            id="description"
            value={service.description}
            onTextChange={(e) => setService({ ...service, description: e.textValue})}
            style={{ height: "150px" }}
          />
        </div>
        <div className="p-field">
          <label htmlFor="lien">Lien</label>
          <InputText
            id="lien"
            value={service.lien}
            onChange={(e) => setService({ ...service, lien: e.target.value })}
          />
        </div>
      </Dialog>

      <Dialog
        visible={deleteDialog}
        style={{ width: "350px" }}
        header="confirmer"
        modal
        footer={deleteDialogFooter}
        onHide={hideDeleteDialog}
      >
        <div className="confirmation-content">
          <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: "2rem" }} />
          {service && <span>Etes-vous sûr de vouloir supprimer <b>{service.libelle}</b>?</span>}
        </div>
      </Dialog>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        dataPerPage={dataPerPage}
        setDataPerPage={setDataPerPage}
        handlePageChange={handlePageChange}
      />
    </div>
  );
}